module.exports = __webpack_public_path__ + "media/images/banner-assets/th/banner1-74ae8f3392278876e3cf617912f531e5.jpg";